<template>
  <div class="home">
    <NavBar />
    <hr />
    <Play />
    <PlayButton />
    <!---<h1 class="display-4 text-center text-white bg-custom">Top's</h1>
    <Table />--->
    <Adventure />
    <News />
    <hr />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "../components/Navbar/Navbar.vue";
import Footer from "../components/Footer/Footer.vue";
import Adventure from "../components/Body/Adventure.vue";
import Play from "../components/Body/Play.vue";
import PlayButton from "../components/Body/PlayButton.vue";
import News from "../components/Body/News.vue";
//import Table from "../components/Body/Table.vue"

export default {
  components: {
    NavBar,
    Play,
    PlayButton,
    Adventure,
    News,
    Footer,
    //Table
  },
};
</script>


<style scoped>
.bg-custom {
  background: rgba(0, 0, 0, 0.479);
}
@keyframes myAnim {
  0%,
  50%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}
hr { 
    background: url('../assets/gem.png') no-repeat top center;
    background-size: contain;
    display: block;
    height: 50px;
    border: 0;
    position: relative;
    animation: myAnim 5s ease 0s infinite normal forwards;
}
hr:before,
hr:after {
    content: '';
    display: block;
    position: absolute;
    background: none;
    height: 2px;
    top: 8px;
}
hr:before {
    left: 0;
    right: 50%;
    margin-right: 10px;
}
hr:after {
    right: 0;
    left: 50%;
    margin-left: 10px;
}
</style>